<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Pagination from "@/components/standard/Induction/components/InductionPagination";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CustodiaHistoriasAPI from "@/services/standards/custodiaHistorias/custodiaHistoriasAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import CustodiaHistoriasPagination from "../../../components/standard/custodiaHistorias/CustodiaHistoriasPagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "3.1.5 Custodia de historias clínicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    Pagination,
    PageHeader,
    Table,
    CheckModal,
    CustodiaHistoriasPagination,
  },
  data() {
    return {
      title: "3.1.5 Custodia de historias clínicas ocupacionales",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Custodia de historias clínicas ocupacionales",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: "",
      file: null,
      file2: null,
      custodia: {
        application_date: null,
        provider_evaluations: null,
        certificate: null,
        security_license: null,
        observations: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      company: null,
      lastId: 1,
      deleteCount: 0,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
    };
  },
  validations: {
    file: {
      required,
    },
    file2: {
      required,
    },

    custodia: {
      provider_evaluations: {
        required,
      },
      application_date: {
        required,
      },
    },
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(27)
        .then((response) => {
          this.itemData = response;
          this.loading1 = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.5/${this.lastId}/certificado/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.5/${this.lastId}/certificado/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.custodia.certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async uploadDocument2() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.5/${this.lastId}/licencia/${this.file2.name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.5/${this.lastId}/licencia/${this.file2.name}`;
        }
        const result = await uploadDocument(url, this.file2);
        if (result) {
          this.custodia.security_license = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading1 = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading1 = false
        return;
      } else {
        let doc1 = await this.uploadDocument();
        if (doc1) {
          let doc2 = await this.uploadDocument2();
          if (doc2) {
            CustodiaHistoriasAPI.save(this.custodia)
              .then((resp) => {
                const itemChange = {
                  companies_id: this.companyID,
                  item_id: 27,
                  status: 'Pendiente',
                };
                newScoresAPI.calculateScores(itemChange)
                  .then((response) => {
                    this.sendNotification(62, 27, true);
                    this.loading1 = false
                    setTimeout(() => {
                      Swal.fire({
                        title: "¡Éxito!",
                        text: "¡Se ha registrado con éxito!",
                        type: "success",
                        icon: "success",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                    }, 1500);
                    window.location.reload();
                  })
                  .catch((error) => {
                    this.loading1 = false
                    setTimeout(() => {
                      Swal.fire({
                        title: "Error",
                        text: "¡No se ha podido registrar!",
                        icon: "error",
                        type: "error",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                      window.location.reload();
                    }, 1000);
                    console.log(error);
                  });
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            this.loading1 = false
            setTimeout(() => {
              Swal.fire({
                title: "¡Error",
                text: "¡No se ha podido registrar!, error licencia",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }, 2000)
          }
        } else {
          this.loading1 = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error",
              text: "¡No se ha podido registrar!, error certificado",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000)
        }
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 27)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },


    changeItemStatus(itemStatus) {
        const itemChange = {
          companies_id: this.companyID,
          item_id: 27,
          status: itemStatus,
        };
        newScoresAPI.calculateScores(itemChange)
          .then((response) => {
            Swal.fire({
              title: "¡Éxito!",
              text: "¡Se ha cambiado el estado del ítem con éxito!",
              icon: "success",
              type: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            setTimeout(() => window.location.reload(), 2000)
          })
          .catch((error) => {
            Swal.fire({
              title: "¡ERROR!",
              text: "¡No se ha actualizado el estado del ítem!",
              type: "error",
              icon: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });

            setTimeout(() => window.location.reload(), 2000)
            console.log(error);
          });

    },

    deleteCustodia(id) {
      CustodiaHistoriasAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 27,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCustodia() {
      CustodiaHistoriasAPI.get(this.companyID)
        .then((response) => {
          this.loading = false;
          this.list = response.data.data;
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getCustodia();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12 pl-3">
                  <CheckModal>
                    <p class="text-justify">
                      La información relacionada con las evaluaciones médicas
                      ocupacionales, hace parte de la historia clínica del
                      trabajador, por esta razón, solo deben tener acceso el
                      trabajador y el personal de la salud. La empresa debe
                      garantizar que solo cuenta con los conceptos de aptitud
                      laboral emitidos después de la realización de las
                      evaluaciones y que la historia clínica ocupacional está
                      custodiada por médico especialista en SST contratado o por
                      la IPS que apoya en la realización de las evaluaciones. En
                      este ítem se debe cargar el certificado que acredite quien
                      tiene la custodia de las historias.
                    </p>
                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Fecha solicitud certificado" label-for="trainingDate">
                    <b-form-input type="date" v-model="custodia.application_date" id="trainingDate" :class="{
                      'is-invalid':
                        $v.custodia.application_date.$error && submitted,
                    }" :disabled="!allowAccess() || !getRole('Crear')">
                    </b-form-input>
                    <div v-if="submitted && $v.custodia.application_date.$error">
                      <small v-if="!$v.custodia.application_date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Proveedor evaluaciones médicas" label-for="trainingDate">
                    <b-form-input type="text" v-model="custodia.provider_evaluations" id="trainingDate" maxlength="50"
                      :class="{
                        'is-invalid':
                          $v.custodia.provider_evaluations.$error && submitted,
                      }" :disabled="!allowAccess() || !getRole('Crear')">
                    </b-form-input>
                    <div v-if="submitted && $v.custodia.provider_evaluations.$error">
                      <small v-if="!$v.custodia.provider_evaluations.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Certificado de la custodia de la historia clínica"
                    label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="evidence" ref="evidence"
                      name="evidence" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                    <div v-if="submitted && $v.file.$error">
                      <small v-if="!$v.file.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Licencia en seguridad y salud en el trabajo del médico"
                    label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="evidence2" ref="evidence2"
                      name="evidence2" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file2"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                    <div v-if="submitted && $v.file2.$error">
                      <small v-if="!$v.file2.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="custodia.observations" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" v-on:click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>

              <hr class="px-3" />
              <div class="card-body">
                <div class="row pb-3 px-3">
                  <div class="col-6">
                    <form @submit.prevent="fetch()" class="form-inline">
                      <div class="form-group mr-2">
                        <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                          class="form-control px-2" placeholder="Buscar"></b-form-input>

                        <div class="col-1">
                          <button type="submit" class="btn btn-primary px-2">
                            Buscar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="col-6"></div>
                </div>

                <div class="table-responsive px-3">
                  <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded px-3">
                    <thead>
                      <tr>
                        <th class="text-center align-middle">Fecha</th>
                        <th class="text-center align-middle">
                          Proveedor de evaluaciones m.
                        </th>
                        <th class="text-center align-middle">
                          Certificado de la custodia
                        </th>
                        <th class="text-center align-middle">
                          Lic. en SST del médico
                        </th>
                        <th class="text-center align-middle">Acciones</th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-for="item in list" :key="item.id">
                        <td class="text-center align-middle">
                          {{ dateConvert(item.application_date) }}
                        </td>

                        <td class="text-center align-middle">
                          {{ item.provider_evaluations }}
                        </td>

                        <td class="text-center align-middle">
                          <div v-if="item.certificate === null">
                            <h6>No hay archivo disponible</h6>
                          </div>
                          <div v-else>
                            <button :disabled="!allowAccess()" style="
                                background-color: transparent !important;
                                border: none;
                              " type="button" @click="gotoDigitalOcean(`${item.certificate}`)">
                              <i class="mdi mdi-cloud-download"></i>
                            </button>
                          </div>
                        </td>
                        <td class="text-center align-middle">
                          <div v-if="item.security_license === null">
                            <h6>No hay archivo disponible</h6>
                          </div>
                          <div v-else>
                            <button :disabled="!allowAccess()" style="
                                background-color: transparent !important;
                                border: none;
                              " type="button" @click="
                                gotoDigitalOcean(`${item.security_license}`)
                                ">
                              <i class="mdi mdi-cloud-download"></i>
                            </button>
                          </div>
                        </td>
                        <td class="text-center align-middle">
                          <div class="col-sm-12">
                            <b-dropdown variant="primary" :disabled="!allowAccess() || !getRole('Editar')">
                              <template v-slot:button-content>
                                <i class="mdi mdi-eye"></i>
                              </template>
                              <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                                v-b-modal="`modal${item.id}`">
                                Editar
                              </b-dropdown-item>
                              <b-modal :id="`modal${item.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                <div class="text-justify">
                                  <h4 class="mt-2 text-primary text-center">
                                    Advertencia
                                  </h4>
                                  <p class="mt-3">
                                    Al modificar esta información se quitará el
                                    puntaje correspondiente a este ítem y será
                                    necesario realizar nuevamente la validación
                                    por parte del usuario responsable de
                                    Emisión.
                                  </p>
                                  <button type="button" @click="
                                    goPage(
                                      `/forms/estandares/custodia-historias-editar/${item.id}`
                                    )
                                    " class="btn btn-primary my-2 mx-2" data-dismiss="`modal${item.id}`"
                                    :disabled="!allowAccess()">
                                    Continuar
                                  </button>
                                  <button type="button" @click="$bvModal.hide(`modal${item.id}`)"
                                    class="btn btn-danger btn mx-2" data-dismiss="modal">
                                    Cancelar
                                  </button>
                                </div>
                              </b-modal>
                              <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')" :to="{
                                path: `/forms/estandares/custodia-historias-ver/${item.id}`,
                              }">
                                Ver
                              </b-dropdown-item>
                              <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                " v-on:click="deleteCustodia(item.id)">Eliminar</b-dropdown-item>
                            </b-dropdown>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <CustodiaHistoriasPagination ref="paginator" :search="search" @loading="(load) => (loading = load)"
                    @fetch="(items) => (list = items)" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
